import { Landmark, IslandInfo } from '../types';

export const landmarks: Landmark[] = [
  {
    id: '1',
    name: 'Basile Island',
    description: 'Basile Island was once the most populated island within Southern Group. While the island shacks remain, the island rarely reaches the full capacity it used to see every year during the crayfishing season.',
    position: { lat: -28.875023, lng: 113.962863 },
    category: 'camp',
    imageUrl: require('../assets/slideshow/basile1.jpg'),
  },
  
];

export const islandInfo: IslandInfo = {
  name: 'Abrolhos Islands',
  description: 'Located approximately 70 kilometers (38 nautical miles) West of Geraldton, Western Australia.',
  facts: [
    'The Houtman Abrolhos Islands are a chain of 122 islands and associated coral reefs in the Indian Ocean off the west coast of Australia. This unique archipelago is known for its rich marine biodiversity, historical significance, and stunning natural beauty. The islands are a haven for wildlife, including seabirds, sea lions, and diverse marine life.',
    'Comprises three main groups: Pelsaert, Easter, and Wallabi along with North Island.',
    'Home to some of the the southernmost coral reefs in the Indian Ocean.',
    'Home of the worlds first ecologically sustainable fishery (Western Rock Lobster).',
    'Rich in maritime history, including the famous Batavia shipwreck of 1629 among many others.',
    'Over 90 species of birds call the islands home.',
    'The waters are home to more than 190 species of coral and around 400 species of fish.',
  ],
};

